import { Location } from "@remix-run/router";
import React, { useState } from "react";
import { useLocation } from "react-router";
import { useTheme } from "../../../../../hooks";
import { NavigationLinkType } from "../../../../../types";
import { Link } from "../../../../links";
import { checkForActive } from "../../../v1/NavigationUtil";
import NavItemContent from "./NavItemContent";
import { NavItemContainer } from "./NavItemStyles";

const NavItem: React.FC<NavigationLinkType> = ({
  name,
  to,
  id,
  iconCategory,
  icon,
  onClick,
  visible = true,
  active = false,
  displayName = true,
}) => {
  const { Theme } = useTheme();
  const location: Location = useLocation();
  const [hovered, setHovered] = useState<boolean>(false);
  const itemActive: boolean = active || (!!to ? checkForActive(location, to) : false);
  return !!visible ? (
    <NavItemContainer active={itemActive} onMouseOver={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      {to ? (
        <Link
          to={to}
          styles={{
            ...Theme.link,
            color: hovered
              ? Theme.nav.horizontal.nav.hover.color
              : active
              ? Theme.nav.horizontal.nav.active.color
              : Theme.nav.horizontal.nav.color,
            size: "1rem",
            hover: Theme.nav.horizontal.nav.hover.color,
          }}
        >
          <NavItemContent
            id={id}
            name={name}
            icon={icon}
            iconCategory={iconCategory}
            onClick={onClick}
            displayName={displayName}
          />
        </Link>
      ) : (
        <NavItemContent
          id={id}
          name={name}
          icon={icon}
          iconCategory={iconCategory}
          onClick={onClick}
          displayName={displayName}
        />
      )}
    </NavItemContainer>
  ) : null;
};

export default NavItem;
